export const defaultValueGet = (
  defaultValues: any,
  name: string,
  predefinedDefaultValue: any
) => {
  const valueDefault =
    defaultValues && defaultValues[name]
      ? defaultValues[name]
      : predefinedDefaultValue;

  return valueDefault;
};

export const defaultValuePathGet = (
  defaultValues: any,
  path: string[],
  predefinedDefaultValue: any
) => {
  let res = predefinedDefaultValue;
  let obPathCorrect: boolean = true;
  const n = path.length;
  if (n >= 1) {
    if (n === 1) {
      res = defaultValueGet(defaultValues, path[0], predefinedDefaultValue);
    } else {
      let currentOb = defaultValues;
      for (let i = 0; i <= n - 2; i++) {
        const currentPropertyName = path[i];
        if (currentOb && currentOb[currentPropertyName]) {
          currentOb = currentOb[currentPropertyName];
        } else {
          obPathCorrect = false;
          break;
        }
      }
      if (obPathCorrect) {
        res = defaultValueGet(currentOb, path[n - 1], predefinedDefaultValue);
      }
    }
  }

  return res;
};
